import fetch from "../utils/fetch";
//用户信息列表
export const fetchUserList = (params) =>
  fetch(`user/list`, {
    method: "get",
    params,
  });

//查询积分明细
export const fetchIntegraDetails = (params) =>
  fetch(`user/integral`, {
    params,
  });

//会员购买记录
export const fetchVipRecord = (params) =>
  fetch(`/user/buy`, {
    params,
  });

//查询会员等级列表
export const fetchLevelList = () => fetch(`/rule/integral/memberGrade`);

//用户的邀请记录
export const fetchtInviteRecord = (userId) =>
  fetch(`/user/invitation/${userId}`);
